import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const ArrowDownThinIconSvg = () => (
  <svg
    width="12"
    height="6"
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0694 0.157354L6.38444 4.76835C6.28221 4.86948 6.14423 4.9262 6.00044 4.9262C5.85664 4.9262 5.71866 4.86948 5.61644 4.76835L0.931436 0.158354C0.82858 0.0572781 0.690143 0.000641788 0.545936 0.000641775C0.401729 0.000641762 0.263292 0.0572781 0.160436 0.158354C0.109787 0.207731 0.0695358 0.266746 0.0420518 0.331923C0.0145679 0.3971 0.000408656 0.46712 0.00040865 0.537854C0.000408644 0.608589 0.0145678 0.678607 0.0420518 0.743784C0.0695357 0.808961 0.109787 0.867977 0.160436 0.917354L4.84444 5.52735C5.15296 5.83028 5.56806 6 6.00044 6C6.43281 6 6.84791 5.83028 7.15644 5.52735L11.8404 0.917355C11.8912 0.867962 11.9316 0.808885 11.9592 0.743615C11.9868 0.678346 12.001 0.60821 12.001 0.537354C12.001 0.466499 11.9868 0.396364 11.9592 0.331095C11.9316 0.265825 11.8912 0.206747 11.8404 0.157354C11.7376 0.0562787 11.5991 -0.000357663 11.4549 -0.000357676C11.3107 -0.000357688 11.1723 0.0562786 11.0694 0.157354Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowDownThinIcon: FC<Partial<CustomIconComponentProps>> = (
  props
) => <Icon component={ArrowDownThinIconSvg} {...props} />;

export default ArrowDownThinIcon;

ArrowDownThinIcon.displayName = "ArrowDownThinIcon";
